/**
 * Notifications API Client
 *
 * Bell notifications for the current user (list + clear).
 */
import { notificationsApiClient } from './client';
/**
 * List the current user's notifications (default: unread only)
 */
export async function listNotifications(status = 'unread') {
    return notificationsApiClient.get(`/notifications?status=${status}`);
}
/**
 * Clear a notification so it no longer shows on the bell
 */
export async function clearNotification(notificationId) {
    return notificationsApiClient.post(`/notifications/${notificationId}/clear`);
}
